import {Component} from '@angular/core';
import {NavParams, ViewController} from 'ionic-angular';
import {AppConfigService} from "../../services/appConfig.service";
import {UserService} from "../../services/user.services";

//1.本页面列表详情页面和2.每日下级列表详情共用
//和投注详情样式一致
@Component({
    templateUrl: 'reportWinLossDetails.html',
    selector: 'report-win-loss-details-page',
})
export class ReportWinLossDetailsPage {
    private betInfo: any;
    private title: string;

    constructor(public params: NavParams, private userService: UserService, public viewCtrl: ViewController) {
        this.betInfo = params.get('data');
        if (params.get('type') == 1) {
            this.title = "Liệt kê chi tiết";
        } else {
            this.title = "Xem chi tiết cược";
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/reportWinLossDetails/reportWinLossDetails.ts